import { IBoardUserMetas } from '../types';
import { AT_BOARD_USER_META_ACTION_SET, TBoardUserMetasAction } from '../actions/types';
import { boardUserMetaReducer } from 'app/store/model/boardUserMeta/reducers/boardUserMetaReducer';

const initialState: IBoardUserMetas = {};

export const boardUserMetasReducer = (
    state = initialState,
    action: TBoardUserMetasAction
): IBoardUserMetas  => {
    switch (action.type) {
        case AT_BOARD_USER_META_ACTION_SET: {
            const {boardId, boardUserMetaAction} = action;
            return {
                ...state,
                [boardId]: boardUserMetaReducer(state[boardId], boardUserMetaAction)
            }
        }
        default: {
            return state;
        }
    }
};
